import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';
import * as Chart from 'chart.js';

@Component({
    selector: 'automation-administration',
    templateUrl: './automation-administration.component.html',
    styleUrls: ['./automation-administration.component.css']
})
export class AutomationAdministrationComponent implements OnInit {

    public sheets: any[] = [];

    public password: string = '';

    public errorOverLay = null;

    public domainData = {};

    constructor(private automationService: AutomationService) { }

    public ngOnInit() {
        this.automationService.loadRpmData().subscribe((data) =>{

            this.domainData = data;

            this.domainData && this.drawChart();
        }), (error) =>{
            console.log(error);
        };
    }

    public setPassword() {

        if (this.password.trim()) {

            this.automationService.password = this.password;

            this.errorOverLay = {
                message: 'Password is saved successfully',
                success: true
            };

            this.password = '';
        } else {

            this.errorOverLay = {
                message: 'No password to set',
            };
        }

    }

    public removeRolledBackProcesses() {

        this.automationService.registerSpinner.next(true);

        this.automationService.removeRolledBackProcesses()
            .subscribe((data) => {
                this.automationService.registerSpinner.next(false);

                if (data) {
                    this.errorOverLay = {
                        message: 'Processes are removed successfully',
                        success: true
                    };
                } else {
                    this.errorOverLay = {
                        message: 'There are no rolled back processes to remove',
                    };
                }

            }, (error) => {

                if (error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }

                this.automationService.registerSpinner.next(false);
            });
    }

    public closeOverLay() {

        this.errorOverLay = null;
    }



 drawChart() {
    const labels = [];
    for (let i = 59; i >= 0; i--) {
      labels.push('-' + i + ' min');
    }

    const datasets = [];
    const colors = [
      'rgba(75, 192, 192, 1)',
      'rgba(255, 99, 132, 1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)'
    ];

    let colorIndex = 0;

    for (const domain in this.domainData) {
      if (this.domainData.hasOwnProperty(domain)) {
        datasets.push({
          label: domain + ' - Requests per Minute',
          data: this.domainData[domain].perMinute,
          fill: false,
          borderColor: colors[colorIndex % colors.length],
          lineTension: 0.2
        });
        colorIndex++;
      }
    }

    const ctx = (<HTMLCanvasElement>document.getElementById('rpmChart')).getContext('2d');

    new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'HTTP Requests per Minute (Multiple Domains)'
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Minutes Ago'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Requests'
            },
            ticks: {
              beginAtZero: true,
              precision: 0
            }
          }]
        }
      }
    });
  }

  // Simple color generator for lines
  getColor(index: number) {
    const colors = [
      '#42A5F5', '#FF6384', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'
    ];
    return colors[index % colors.length];
  }
}



// WEBPACK FOOTER //
// ./src/app/automation/automation-administration/automation-administration.component.ts